import React from 'react';
import { ArrowRight } from 'lucide-react';

export const Workflow = () => {
  const steps = [
    {
      number: '01',
      title: 'Input',
      description: 'Foreman inputs (or speaks) updates',
    },
    {
      number: '02',
      title: 'Process',
      description: 'AI processes logic ties, durations, cost impact',
    },
    {
      number: '03',
      title: 'Update',
      description: 'Dashboard updates instantly',
    },
    {
      number: '04',
      title: 'Alert',
      description: 'Leadership receives red/yellow/green alerts',
    },
    {
      number: '05',
      title: 'Report',
      description: 'Automated reports sent daily/weekly',
    },
  ];

  return (
    <section id="workflow" className="py-24 bg-[#1A2733] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
            HOW IT <span className="text-[#30D5C8]">WORKS</span>
          </h2>
          <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] max-w-3xl mx-auto">
            From field input to executive reporting in seconds
          </p>
        </div>

        <div className="relative">
          {/* Desktop view - horizontal flow */}
          <div className="hidden lg:flex items-start justify-between relative">
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <div className="flex flex-col items-center flex-1 group">
                  <div className="relative">
                    <div className="w-20 h-20 bg-[#30D5C8]/10 border-2 border-[#30D5C8] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#30D5C8]/20 transition-all duration-300">
                      <span className="font-['Montserrat'] font-bold text-2xl text-[#30D5C8]">
                        {step.number}
                      </span>
                    </div>
                  </div>
                  <h3 className="font-['Montserrat'] font-bold text-xl text-[#F5F7F8] mb-2">
                    {step.title}
                  </h3>
                  <p className="text-[#CBD3D9] font-['Open_Sans'] text-center max-w-[180px]">
                    {step.description}
                  </p>
                </div>
                {index < steps.length - 1 && (
                  <div className="flex items-center justify-center pt-10 flex-shrink-0">
                    <ArrowRight className="text-[#30D5C8] opacity-50" size={32} />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Mobile view - vertical flow */}
          <div className="lg:hidden space-y-6">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-[#0D1115]/80 backdrop-blur-sm border border-[#506273]/30 rounded-lg p-6 hover:border-[#30D5C8]/50 transition-all duration-300">
                  <div className="flex items-start space-x-4">
                    <div className="w-16 h-16 bg-[#30D5C8]/10 border-2 border-[#30D5C8] rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="font-['Montserrat'] font-bold text-xl text-[#30D5C8]">
                        {step.number}
                      </span>
                    </div>
                    <div>
                      <h3 className="font-['Montserrat'] font-bold text-xl text-[#F5F7F8] mb-2">
                        {step.title}
                      </h3>
                      <p className="text-[#CBD3D9] font-['Open_Sans']">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div className="flex justify-center py-2">
                    <div className="w-0.5 h-6 bg-[#30D5C8] opacity-50" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};